import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-heading font-bold text-lg">91</span>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">
                91浏览器
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              一款功能强大的移动浏览器，提供极速上网、隐私保护、多标签浏览等核心功能，让您享受流畅安全的浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">文章分类</h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/faq" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/category/version-updates" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  版本更新
                </Link>
              </li>
              <li>
                <a href="#download" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  下载91浏览器
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>support@91browser.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5"></i>
                <span>400-888-9191</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>北京市朝阳区科技园区91号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 91浏览器. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}